import { Injectable } from '@angular/core';

//// -------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     10/11/2017
// Description: Provides configuration settings to the rest of the application
//// -------------------------------------------------------------------------------------------

@Injectable()
export class AppConfigService {


    // Core Configuration
    // Interval between checking for new observations
    public ObservationCheckInterval = 60000;

    // Application name - top left
    public ApplicationName = 'personal health record';

    // Copyright display - bottom right
    public Copyright = '2017-2019 EuroKing';

    // Trust security policy - bottom left

    public Footer = '';

    // App version number
    public Version = '1.4.0';

    // API Host
    // public ApiHost: string = "phr.euroking.com/maternity";
public ApiHost = "e3phr.cornwall.nhs.uk/Maternity_LIVE";

    // API Port
public ApiPort = "";

    // API Port Seperator
public PortSeperator ="";

    // Url To use for logging out
    public AuthenticationLogoutUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/authentication/logout`;

    // Url to use for logging in
    public AuthenticationLogInUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/authentication/login`;

    // Gets a patient
    public PatientGetUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/{patientId}`;

    // Gets a patient
    public PatientGetCurrentPregnancyId =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/{patientId}/Pregnancy`;

    // Gets the patient email address for a given id
    public PatientEmailGetUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Email/{patientId}`;

    // Gets the patient email address for a given id
    public PatientLibraryGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Library`;

    // Gets the patient email address for a given id
    public PatientActivityGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Pregnancy/{pregnancyId}/Activity`;

    // Patient authorisation
    public PatientAuthorisePostUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/authorise`;

    // Patient authorisation
    public PatientDeauthorisePostUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/deauthorise`;

    // Url for posting registrationS
    public PatientRegisterPostUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/register`;

    public PatientResetPasswordPostUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/resetpassword`;

    // Attaches risks and alerts for each patient
    public PatientAttachRisksAlertsUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Attach/RisksAndAlerts`;

    // Checks the status of a patient for Phr registration
    public PatientPhrStatusUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/status/{patientId}`;

    // Gets the text for the patients previous appointment
    public PatientGetPreviousAppointmentUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Pregnancy/GetPreviousAppointment/{pregnancyId}`;

    // Gets a patient id for a given email address
    public PatientIdByEmailGetUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/Id/GetPhrPatientIdByEmail?emailAddress={emailAddress}`;

    // Gets the patient questionnaire
    public PatientQuestionnaireGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/QuestionnaireResult/{questionnaireId}?instanceId={instanceId}`;

    // Checks the status of a patient for Phr registration
    public UserRoleCheckGetUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/adminrole`;

    // Searches for a patient
    public SearchUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/SearchE3/{searchFilter}/{query}/identifiers`;

    // Gets the current trust address
    public TrustAddresses =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/address/all`;

    // Update the trust address
    public UpdateTrustAddress =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/address/update`;

    // Update the trust address
    public AddTrustAddress =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/address/add`;

    // Update the trust address
    public DeleteTrustAddress =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/address/delete`;

    // Gets the current trust schedules
    public TrustSchedules =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/schedules`;

    // Gets the current trust schedules
    public DeleteTrustSchedule =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/schedule/delete`;

    // Gets the current trust schedules
    public UpdateTrustSchedule =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/schedule/update`;

    // Gets the current trust schedules
    public addTrustSchedule =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/trust/schedule/add`;

    // Gets a trust card
    public getTrustCard =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/home/cards/{cardName}`;

    // Gets the current trust schedules
    public getAllTrustCards =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/home/cards/all`;

    // Gets the current trust schedules
    public updateTrustCardPost =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/home/card/update`;

    // Gets the questionnaire definition for EPA
    public GetPhrEpaDefinition =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/PhrEpaQuestionnaireDefinition/Patient/{PregnancyId}`;

    // Gets the questionnaire definition for EPA
    public GetPhrBirthPlanDefinition =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/PhrBirthPlanQuestionnaireDefinition/{PregnancyId}`;

    // Gets the questionnaire definition for EPA
    public PostPhrEpaDefinition =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/PhrEpaQuestionnaireSubmission`;

    // Gets the questionnaire definition for EPA
    public PostBirthPlanDefinition =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/PhrBirthPlanQuestionnaireSubmission`;

    // Resets the password
    public ResetPasswordUrl =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/reset`;

    // The link to use when getting the pdf reports for a patient
    public ReportsGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/{pregnancyId}/PatientPdfReports`;

    // The link to use when getting the pdf reports for a patient
    public ChangePassword =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/authorisation/changepassword`;

    // Gets a single report using the gievn id
    public ReportGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/Patient/{patientId}/Reports/{reportId}`;

    // Useful websites
    public usefulWebsiteGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/usefulwebsites/all`;

    // Useful websites Add
    public usefulWebsiteAdd =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/usefulwebsites/add`;

    public TrustDataQualityGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/dataqualitycontact/get`;

    public TrustDataQualityUpdatePost =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/dataqualitycontact/update`;

    // Useful websites Add
    public usefulWebsiteUpdate =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/usefulwebsites/update`;

    // Useful websites Add
    public usefulWebsiteDelete =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/usefulwebsites/delete`;

    // Useful websites Add
    public logoGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/phr/asset/logo`;

    public TrustReportConfigurationGet =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/reportconfiguration/get`;

    public TrustReportConfigurationPost =
        `https://${this.ApiHost}${this.PortSeperator}${this.ApiPort}/api/v1/trust/reportconfiguration/update`;

    // Restricted areas are only for users in an admin role
    public RestrictedAreas: string[] = [
        '/app/admin/search',
        '/app/admin/contact',
        '/app/admin/websites',
        '/app/admin/card-configuration',
        '/app/admin/report-configuration'
    ];

    // Restricted areas are only for users in an admin role
    public UserAreas: string[] =
        [
            '/app/registration',
            '/app/newpassword',
            '/app/changepassword',
            '/app/aboutme',
            '/app/mybirthplan',
            '/app/mypregnancy',
            '/app/contact',
            '/app/activity',
            '/app/home'
        ];

    // Flag to indicate if the logged in use has access to admin functions
    public IsTrust = false;
    public IsBooked = false;               // Move this to session
    public UserName = '';
    public PatientId: number;
    public PregnancyId: number;
    public PatientInitials = '';
    public Forename = '';
    public IsMobile = false;
    public ShowHeader = true;

    // Will log output to the console. Turn off for production
public LogToConsole = false;

}



// WEBPACK FOOTER //
// ./src/app/services/app-config-service/app-config.service.ts